import { useBaseViewModel } from '@/common';
import { CourseLineEntity } from '@/domains/course-lines/entities';
import { CourseLinePayloadForm } from '@/domains/course-lines/ports/payloads';
import { CreateCourseLineUsecase, UpdateCourseLineUsecase } from '@/domains/course-lines/usecases';
import { notification } from 'antd';
import { useState } from 'react';
import { validateCourseLine } from '../validations';
import { CourseLineHttpRepository } from '../adapters/repositories';
import { getErrorMessage } from '@/components/hooks/useGetErrorMessage';

export default function CourseLineFormViewModel(props?: { detailCourseLine?: CourseLineEntity }) {
  const createCourseLineUC = new CreateCourseLineUsecase(new CourseLineHttpRepository());
  const updateCourseLineUC = new UpdateCourseLineUsecase(new CourseLineHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseLineData, setCourseLineData] = useState<CourseLineEntity>();

  const actionSaveCourseLine = async (payload: CourseLinePayloadForm) => {
    try {
      if (payload.id) {
        const data = await updateCourseLineUC.run(payload);
        setCourseLineData(data);
        notification.success({
          message: 'Course Line Updated',
          description: 'You have successfully updated the course line',
          placement: 'bottomRight',
        });
      } else {
        const data = await createCourseLineUC.run(payload);
        setCourseLineData(data);
        notification.success({
          message: 'Course Line Created',
          description: 'You have successfully created a new course line',
          placement: 'bottomRight',
        });
      }
      return true;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: getErrorMessage(error),
        placement: 'bottomRight',
      });
      return false;
    }
  };

  const validateForm = (props: { detailCourseLine: CourseLineEntity }) => {
    const { schemaCourseLine } = validateCourseLine(props);
    return { schemaCourseLine };
  };

  return {
    loading,
    error,
    courseLineData,
    actionSaveCourseLine,
    validateForm,
  };
}
